'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsModalLoader = exports.CmsModalLoaderUnwrapped = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Sagas = require('decorators/Sagas/Sagas');

var _cms = require('helpers/cms');

var _debounce = require('helpers/debounce');

var _decorator = require('helpers/decorator');

var _deep = require('helpers/deep');

var _verify = require('helpers/verify');

var _modals = require('redux/modules/modals');

var _bound = require('redux/saga/entities/bound');

var _localStorage = require('redux/saga/helpers/local-storage');

var _request = require('redux/saga/selectors/request');

var _CmsModalLoader = require('./CmsModalLoader.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    canShowModal: !(0, _modals.selectActiveModalName)(state),
    modals: (0, _deep.deepExtract)('modules', _bound.cmsWebContent.data(state, 'modals')),
    path: (0, _request.pathSelector)(state)
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  loadCmsData: _CmsModalLoader.loadCmsData,
  showModal: _modals.showModal
};

var EXIT_INTENT_DELAY = 100;
var SCROLL_DELAY = 1000;

var TRIGGERS = {
  LOAD: 'page load',
  SCROLL: 'page scroll',
  EXIT: 'exit intent'
};

var CmsModalLoaderUnwrapped = exports.CmsModalLoaderUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(CmsModalLoaderUnwrapped, _PureComponent);

  function CmsModalLoaderUnwrapped() {
    var _ref2;

    (0, _classCallCheck3.default)(this, CmsModalLoaderUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = CmsModalLoaderUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(CmsModalLoaderUnwrapped)).call.apply(_ref2, [this].concat(args)));

    _this.state = {
      pageMatchersByModalName: {}
    };

    _this.handleScroll = (0, _debounce.debounce)(_this.handleScroll.bind(_this), SCROLL_DELAY);
    _this.handleMouseLeave = (0, _debounce.debounce)(_this.handleMouseLeave.bind(_this), EXIT_INTENT_DELAY);
    return _this;
  }

  (0, _createClass3.default)(CmsModalLoaderUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadCmsData();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.modals && nextProps.modals) {
        this.handleModalDataLoaded(nextProps.modals);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          path = _props.path,
          modals = _props.modals;


      if (prevProps.path !== path || prevProps.modals !== modals) {
        this.maybeTriggerModal(this.props.path, TRIGGERS.LOAD);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll, true);
      document.removeEventListener('mouseleave', this.handleMouseLeave, true);
    }
  }, {
    key: 'handleModalDataLoaded',
    value: function handleModalDataLoaded(modals) {
      if (!modals) {
        return;
      }

      if (modals.some(function (modal) {
        return (modal.triggers || []).includes(TRIGGERS.EXIT);
      })) {
        document.addEventListener('mouseleave', this.handleMouseLeave, true);
      }

      if (modals.some(function (modal) {
        return (modal.triggers || []).includes(TRIGGERS.SCROLL);
      })) {
        window.addEventListener('scroll', this.handleScroll, true);
      }

      var pageMatchersByModalName = modals.reduce(function (memo, modal) {
        memo[modal.name] = (0, _cms.createPageMatcher)(modal.pages);
        return memo;
      }, {});

      this.setState({ pageMatchersByModalName: pageMatchersByModalName });
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave(_ref3) {
      var clientY = _ref3.clientY;

      if (clientY <= 0) {
        this.maybeTriggerModal(this.props.path, TRIGGERS.EXIT);
      }
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      if (window.pageYOffset > 0) {
        this.maybeTriggerModal(this.props.path, TRIGGERS.SCROLL);
      }
    }
  }, {
    key: 'maybeTriggerModal',
    value: function maybeTriggerModal(path, trigger) {
      var pageMatchersByModalName = this.state.pageMatchersByModalName;
      var _props2 = this.props,
          canShowModal = _props2.canShowModal,
          modals = _props2.modals;


      if ((0, _verify.isEmpty)(modals) || !canShowModal) {
        return;
      }

      var seenModals = (0, _localStorage.readSessionStorage)('cmsModalsSeen', []);

      var candidateModal = modals.filter(function (_ref4) {
        var name = _ref4.name;
        return pageMatchersByModalName[name](path);
      }).filter(function (_ref5) {
        var triggers = _ref5.triggers;
        return triggers.includes(trigger);
      }).filter(function (_ref6) {
        var name = _ref6.name;
        return !seenModals.includes(name);
      }).shift();

      if (candidateModal) {
        this.triggerModal(candidateModal);
        (0, _localStorage.writeSessionStorage)('cmsModalsSeen', [].concat((0, _toConsumableArray3.default)(seenModals), [candidateModal.name]));
      }
    }
  }, {
    key: 'triggerModal',
    value: function triggerModal(_ref) {
      var theme = _ref.theme,
          extraProps = (0, _objectWithoutProperties3.default)(_ref, ['theme']);
      var showModal = this.props.showModal;


      var modalProps = (0, _extends3.default)({
        modalConfig: {
          headerClass: (0, _classnames2.default)('modal--640', (0, _defineProperty3.default)({}, 'modal--' + theme, theme))
        }
      }, extraProps);

      showModal('CmsModal', modalProps);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return CmsModalLoaderUnwrapped;
}(_react.PureComponent);

CmsModalLoaderUnwrapped.propTypes = {
  canShowModal: _propTypes2.default.bool.isRequired,
  loadCmsData: _propTypes2.default.func.isRequired,
  modals: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string.isRequired,
    pages: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    triggers: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
  })),
  showModal: _propTypes2.default.func.isRequired,
  path: _propTypes2.default.string.isRequired
};

var CmsModalLoader = exports.CmsModalLoader = (0, _decorator.decorateWith)((0, _Sagas.withSagas)({ watch: _CmsModalLoader.watchCmsModalLoaderSagas }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(CmsModalLoaderUnwrapped);